import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import QRCodeStyling from 'qr-code-styling';
import { Options } from 'qr-code-styling/lib/types';
import i18n from '@/utils/i18n';
import Checkbox from '../../components/Checkbox';
import {
  CheckBoxLabel,
  CheckBoxLabelContainer,
} from '../../components/Checkbox/pickpackCheckbox';

export default function MiniReturnerConfigQRCodeGenerator({
  apiKey,
}: {
  apiKey: string;
}) {
  const [ssid, setSsid] = useState('');
  const [password, setPassword] = useState('');
  const [isGsmVersion, setIsGsmVersion] = useState(true);
  const ref = useRef<HTMLDivElement>(null);
  let qrCodeContent = 'HTTP://VYT.TO/MR/C/?K=' + encodeURIComponent(apiKey);
  if (!isGsmVersion) {
    qrCodeContent +=
      '&S=' +
      encodeURIComponent(ssid.trim()) +
      '&P=' +
      encodeURIComponent(password.trim());
  }

  const qrCodeInitialOptions: Options = {
    width: 400,
    height: 400,
    data: qrCodeContent,
    backgroundOptions: {
      color: '#FFFFFFFF',
    },
    qrOptions: {
      errorCorrectionLevel: 'Q',
    },
  };
  const [qrCode] = useState<QRCodeStyling>(
    new QRCodeStyling(qrCodeInitialOptions),
  );

  useEffect(() => {
    if (ref.current) {
      qrCode.append(ref.current);
    }
  }, [qrCode, ref]);

  useEffect(() => {
    if (!qrCode) return;
    qrCode.update({
      ...qrCodeInitialOptions,
      data: qrCodeContent,
    });
  }, [qrCode, qrCodeContent]);

  return (
    <div className="mt-3">
      <p>{i18n.t('Integrations:generateWifiConfigQrCodeInfo')}</p>
      <CheckBoxLabelContainer onClick={() => setIsGsmVersion(!isGsmVersion)}>
        <Checkbox
          /*
                // @ts-ignore */
          checked={isGsmVersion}
        />
        <CheckBoxLabel>
          {i18n.t('Integrations:miniReturnerGsmVersion')}
        </CheckBoxLabel>
      </CheckBoxLabelContainer>
      <br />
      {!isGsmVersion && (
        <>
          <div className="input-group mb-3">
            <span className="input-group-text" id="inputGroup-sizing-lg">
              {i18n.t('Integrations:generateWifiConfigQrCodeSsid')}
            </span>
            <input
              type="text"
              className="form-control"
              name="wifi-ssid"
              onChange={(e) => {
                setSsid(e.target.value);
              }}
              value={ssid}
            />
          </div>
          <div className="input-group mb-3">
            <span className="input-group-text" id="inputGroup-sizing-lg">
              {i18n.t('Integrations:generateWifiConfigQrCodePassword')}
            </span>
            <input
              type="text"
              className="form-control"
              name="wifi-password"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              value={password}
            />
          </div>
        </>
      )}

      <div ref={ref} />
    </div>
  );
}
